export const Editions = {
	FREE: 'free',
	STANDARD: 'standard',
	PREMIUM: 'premium',
	ESSENTIALS: 'essentials',
	ENTERPRISE: 'enterprise',
} as const;
export type Editions = (typeof Editions)[keyof typeof Editions];

export type EditionExtensionsOptions = {
	edition?: Editions;
};

export type AdminHubExtensionsOptions = {
	migrationSourceUuid?: string;
	grantAccessTo?: string;
} & EditionExtensionsOptions; // Edition extension options included for legacy reasons. Do not include in new extensions

export type StartExtensionsOptions = {
	migrationSourceUuid?: string;
} & EditionExtensionsOptions; // Edition extension options included for legacy reasons. Do not include in new extensions

export type RecommendationExtensionsOptions = {
	recommendationSessionId: string;
	entityId: string;
};

export type ProvisioningPageExtensionsOptions = {
	actions: Actions;
};

export type ProvisioningApiExtensionsOptions = {
	actions: Actions;
	jobName: string;
	jobParams: {
		[key: string]: any;
	};
};

export const Behaviours = {
	LAND: 'land',
	CLOSE: 'close',
} as const;
export type Behaviours = (typeof Behaviours)[keyof typeof Behaviours];

export const TargetTabs = {
	SAME: 'same',
	NEW: 'new',
} as const;
export type TargetTabs = (typeof TargetTabs)[keyof typeof TargetTabs];

export const Prompts = {
	NEXT: 'next',
	CLOSE: 'close',
	GO_TO_PRODUCT: 'go-to-product',
	RETURN_TO_PRODUCT: 'return-to-product',
} as const;
export type Prompts = (typeof Prompts)[keyof typeof Prompts];

type LandBehaviourOptions = {
	behaviour: typeof Behaviours.LAND;
	prompt: Prompts;
	options?: {
		targetTab?: TargetTabs;
		urlParams?: {
			[key: string]: string | number;
		};
	};
};

type CloseBehaviourOptions = {
	behaviour: typeof Behaviours.CLOSE;
	prompt: Prompts;
};

type Action = CloseBehaviourOptions | LandBehaviourOptions;

type Actions = { primary: Action; secondary?: Action } | { primary?: Action; secondary: Action };
